module.exports = __webpack_public_path__ + "img/outdent.e61f76ea.svg";